new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    

    waitForElementToExist('.categories').then(element => {
        if (window.matchMedia("(max-width: 991px)").matches) {
            const categoriesHome = document.querySelector('.home .categories');
            if(categoriesHome) {
                $('#categories-home-carrousel').slick({
                    swipeToSlide: true, 
                    touchThreshold: 100,
                    arrows: false,
                    infinite: false,
                    autoplay: true,
                    dots: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    speed: 1000,
                    autoplaySpeed: 3000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: 'unslick'
                        }
                    ]
                });
            }
        } 
        if (window.matchMedia("(min-width: 992px)").matches) {
            const categoresItem = document.querySelectorAll('.home .categories .categories-item');
            if(categoresItem.length >= 5) {
                $(document).ready(function () {
                    function initSlick() {
                        const $carousel = $('#categories-home-carrousel');
                        const itemCount = $carousel.children().length;
                        const windowWidth = window.innerWidth;
                
                        // Destroi o Slick se já estiver ativo
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('unslick');
                        }
                
                        if (windowWidth >= 1366 && itemCount > 6) {
                            $carousel.slick({
                                swipeToSlide: true, 
                                touchThreshold: 100,
                                arrows: false,
                                dots: false,
                                mobileFirst: true,
                                slidesToShow: 6,
                                slidesToScroll: 1,
                                speed: 1000,
                                autoplay: true,
                                autoplaySpeed: 1000
                            });
                        } else if (windowWidth >= 992 && windowWidth < 1366 && itemCount > 5) {
                            $carousel.slick({
                                swipeToSlide: true, 
                                touchThreshold: 100,
                                arrows: false,
                                dots: false,
                                mobileFirst: true,
                                slidesToShow: 5,
                                slidesToScroll: 1,
                                speed: 1000,
                                autoplay: true,
                                autoplaySpeed: 1000
                            });
                        } else if (windowWidth < 992) {
                            $carousel.slick({
                                swipeToSlide: true, 
                                touchThreshold: 100,
                                arrows: false,
                                dots: false,
                                mobileFirst: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                speed: 1000,
                            });
                        }
                    }
                
                    // Inicializa o Slick quando a página é carregada
                    initSlick();
                
                    // Reativa ou desativa o Slick ao redimensionar a janela
                    $(window).on('resize', function () {
                        initSlick();
                    });
                });
                
            }
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list2');
        if (firstCarrousel) {
            $('#product_list2').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list3');
        if (firstCarrousel) {
            $('#product_list3').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.she-use').then(element => {
        const banner = element.querySelector('.she-use__list');

        if(banner) {
            $('.she-use__list').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 7,
                            arrows: true,
                            autoplay: false,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.rotation-banner').then(element => {
        $('#carrousel-banner-photos, #carrousel-banner-photos2, #carrousel-banner-photos3, #carrousel-banner-photos4, #carrousel-banner-photos5').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.banner-select .banner-select-name');
            let initVitrine = element.querySelectorAll('.banner-photos .banner-photos-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Refresh slick carousels
                    const carouselIds = [
                        '#carrousel-banner-photos',
                        '#carrousel-banner-photos2',
                        '#carrousel-banner-photos3',
                        '#carrousel-banner-photos4',
                        '#carrousel-banner-photos5'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('refresh')
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }
    });

    waitForElementToExist('.rotation-vitrine.first-rotation').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll:1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);
    
            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }
    
                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function(i, c){
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);
    
                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');
                
                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }
    
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                });
    
                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-vitrine.second-rotation').then(element => {
        $('#carrousel-product-list3').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list4').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll:1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);
    
            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }
    
                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function(i, c){
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);
    
                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list3',
                        '#carrousel-product-list4'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');
                
                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }
    
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                });
    
                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list3, #carrousel-product-list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-compre-por-numeracao').then(element => {
        if (element) {
            let rotationNames = element.querySelectorAll('.rotation-compre-por-numeracao-content-list h3');
            let initVitrine = element.querySelectorAll('.rotation-compre-por-numeracao-content-list-items ul');
            initVitrine = Array.from(initVitrine);
    
            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
    
                }
    
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                });
    
                // Initial update for the first active tab
                activeTab(0);
            }
        }
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                            dots: false,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

});